<template>
  <el-dialog :width="this.getSmallDevice() ? '90%' : '55%'" :visible.sync="dialog.showNews" @close="goNextPage()">
    <div v-html="notice.content"></div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="goNextPage()">{{ $t("pages.button.confirm") }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { mapGetters } from "vuex"

import { api } from "@/utils/api.js"

export default {
  name: "PageNotice",
  data() {
    return {
      notice: {
        title: "",
        content: "",
      },
      dialog: {
        showNews: false,
      },
    }
  },
  mounted() {
    this.init()
  },
  updated() {
    this.$nextTick(() => {
      this.bindLink()
    })
  },
  methods: {
    ...mapGetters(["getLanguage", "getSmallDevice"]),
    async init() {
      const { data: noticeList } = await api.apiGetNoticeList()
      //若未設定或是未啟用則會回傳空值
      if(!noticeList || JSON.stringify(noticeList) === "{}") {
        this.goNextPage()
        return
      }
      //目前只會回傳一筆,只抓第一筆公告
      this.notice.title = noticeList[Object.keys(noticeList)[0]][this.getLanguage()].noticeTitle
      this.notice.content = noticeList[Object.keys(noticeList)[0]][this.getLanguage()].noticeContent
      this.dialog.showNews = true
    },
    goNextPage() {
      this.$router.push({ path: "/MyReservation" })
    },
    bindLink() {
      //找出html內的下載檔案tag,並綁定點擊事件
      const link = document.getElementById("download-file")
      if (link) {
        link.addEventListener("click", this.downloadVendorLoginTutorialFile)
      }
    },
    downloadVendorLoginTutorialFile(event) {
      event.preventDefault()
      const vueInstance = this
      api
        .apiGetVendorLoginTutorialFile()
        .then((response) => {
          const blob = new Blob([response.data], {
            type: "application/pdf",
          })
          const link = document.createElement("a")
          link.href = URL.createObjectURL(blob)
          link.download = vueInstance.$t("pages.wording.VendorLoginTutorialFileName")
          link.click()
          URL.revokeObjectURL(link.href)
        })
        .catch((error) => {
          console.log(error)
        })
    },
  },
}
</script>
